<template>
    <v-container fluid>
        <v-card class="pa-4 mb-4" outlined>
            <v-card-title class="text-h6 pa-0 mb-3">{{ $t('ticketSuporteFluxo.tituloRelatorio') }}</v-card-title>
            <v-row dense align="center">
                <v-col cols="12" sm="4" md="3">
                    <v-text-field v-model="dtInicio" type="date" :label="$t('ticketSuporteFluxo.periodoInicio')" dense outlined hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                    <v-text-field v-model="dtFim" type="date" :label="$t('ticketSuporteFluxo.periodoFim')" dense outlined hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="6" class="d-flex align-center">
                    <v-btn color="primary" class="mr-3" :loading="carregando" @click="carregar">
                        <v-icon left>mdi-magnify</v-icon>
                        {{ $t('button.search') }}
                    </v-btn>
                    <export-table-csv
                        :content="items"
                        :headers="headers"
                        :title="$t('ticketSuporteFluxo.tituloRelatorio')"
                        filename="relatorio_suporte"
                        :local-row-limit="100000"
                    ></export-table-csv>
                </v-col>
            </v-row>
        </v-card>

        <v-row v-if="resumo" dense>
            <v-col v-for="k in indicadores" :key="k.rotulo" cols="6" md="3">
                <v-card class="pa-3" outlined>
                    <div class="text-caption grey--text">{{ k.rotulo }}</div>
                    <div class="text-h5">{{ k.valor != null ? k.valor : '-' }}</div>
                </v-card>
            </v-col>
            <v-col v-for="g in grupos" :key="g.titulo" cols="12" md="6" lg="4">
                <v-card class="pa-3" outlined>
                    <div class="text-subtitle-2 mb-2">{{ g.titulo }}</div>
                    <v-simple-table dense>
                        <tbody>
                            <tr v-for="l in g.linhas" :key="l.nome">
                                <td>{{ l.nome }}</td>
                                <td class="text-right">{{ l.valor }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
            </v-col>
        </v-row>

        <v-card v-if="resumo" class="mt-4" outlined>
            <v-data-table :headers="headers" :items="items" :loading="carregando" item-key="id_ticket" dense></v-data-table>
        </v-card>
    </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import ExportTableCSV from '@/components/ExportTableCSV.vue';

function isoDia(d) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export default {
    name: 'RELTicketsSuporte',
    components: { 'export-table-csv': ExportTableCSV },
    data() {
        const hoje = new Date();
        const inicio = new Date(hoje.getTime() - 30 * 86400000);
        return { dtInicio: isoDia(inicio), dtFim: isoDia(hoje), items: [], resumo: null, carregando: false };
    },
    computed: {
        headers() {
            const t = (k) => this.$t(`ticketSuporteFluxo.${k}`);
            return [
                { text: t('codigo'), value: 'cod_ticket' },
                { text: t('titulo'), value: 'titulo' },
                { text: t('status'), value: 'status_dispatcher_extenso' },
                { text: t('familia'), value: 'familia_atendimento_extenso' },
                { text: t('solicitante'), value: 'solicitante' },
                { text: t('grupo'), value: 'grupo_solucionador' },
                { text: t('abertura'), value: 'dt_inclusao_extenso' },
                { text: t('fechamento'), value: 'dt_finalizacao_extenso' }
            ];
        },
        indicadores() {
            const r = this.resumo;
            const t = (k) => this.$t(`ticketSuporteFluxo.${k}`);
            return [
                { rotulo: t('total'), valor: r.total },
                { rotulo: t('backlog'), valor: r.backlog.total },
                { rotulo: t('antiguidadeMedia'), valor: r.backlog.antiguidadeMediaHoras },
                { rotulo: t('tempoResolucao'), valor: r.tempoMedioResolucaoHoras }
            ];
        },
        grupos() {
            const r = this.resumo;
            const t = (k) => this.$t(`ticketSuporteFluxo.${k}`);
            const linhas = (mapa) => Object.keys(mapa).sort().map((nome) => ({ nome, valor: mapa[nome] }));
            return [
                { titulo: t('porStatus'), linhas: linhas(r.porStatus) },
                { titulo: t('porFamilia'), linhas: linhas(r.porFamilia) },
                { titulo: t('porPeriodo'), linhas: linhas(r.porPeriodo) },
                { titulo: t('porGrupo'), linhas: linhas(r.porGrupo) },
                { titulo: t('porSolicitante'), linhas: linhas(r.porSolicitante) },
                {
                    titulo: t('tempoPorStatus'),
                    linhas: r.tempoMedioPorStatus.map((s) => ({ nome: s.status || `#${s.id_status}`, valor: s.horas }))
                }
            ];
        }
    },
    mounted() {
        this.carregar();
    },
    methods: {
        async carregar() {
            this.carregando = true;
            try {
                const res = await apiController.request(apiController.endpoints.getRelticketssuporte, {
                    data: { dt_inicio: this.dtInicio, dt_fim: this.dtFim },
                    silent: true
                });
                this.items = (res.data && res.data.items) || [];
                this.resumo = (res.data && res.data.resumo) || null;
            } catch (e) {
                EventBus.$emit('show-error', { error: e });
            } finally {
                this.carregando = false;
            }
        }
    }
};
</script>
